import { readonly, ref } from 'vue';

import type { UseExpiredAuthContextReturn } from '../types/useExpiredAuthContext.type';

const expiredAuthContextSignal = ref(0);

/**
 * Comparte una señal a nivel de aplicación entre los flujos de autenticación
 * cuando el contexto temporal del login expira y la UI debe reiniciarse entre
 * aplicaciones aisladas.
 *
 * @returns Señal y notificador para propagar eventos de contexto de autenticación expirado.
 */
export function useExpiredAuthContext(): UseExpiredAuthContextReturn {
  function notifyExpiredAuthContext(): void {
    expiredAuthContextSignal.value += 1;
  }

  return {
    expiredAuthContextSignal: readonly(expiredAuthContextSignal),
    notifyExpiredAuthContext,
  };
}